<template>
    <!-- 工程建设质量管理小组竞赛活动 -->
    <div class="form_right group-award">
        <div id="sj_info" class="form_1">
            <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
            <tips title="基本信息" background="#FEF8EF" border="#FFB700" :states="basicFull"></tips>
            <el-form ref="ruleForm">
                <el-tabs v-model="activeName" style="margin-top: 16px">
                    <div class="my_form">
                        <div class="form_title" style="height: 62px">
                            企业名称
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.company" placeholder="点击输入" type="text" @blur="checkedRepeat">
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title" style="height: 62px">
                            小组名称
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.group" placeholder="点击输入" type="text">
                        </div>
                    </div>
                    <div class="my_form">
                        <div class="form_title" style="height: 62px">
                            小组人数
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.group_people_num"
                                   type="number"
                                   :min="0" placeholder="点击输入">
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title" style="min-height: 62px">
                            小组成员(不超过10人)
                        </div>
                        <div class="group-people--container">
                            <el-tag
                                v-for="(tag, index) in ruleForm.group_people"
                                :key="index"
                                closable
                                class="group-people--tag"
                                :disable-transitions="false"
                                @close="handleCloseTag(tag)">
                                {{ tag }}
                            </el-tag>
                            <el-input
                                v-if="inputVisible"
                                ref="saveTagInput"
                                v-model="inputValue"
                                class="input-new-tag"
                                size="small"
                                @keyup.enter.native="handleInputTagConfirm"
                                @blur="handleInputTagConfirm">
                            </el-input>
                            <el-button v-else-if="ruleForm.group_people.length < 10" class="button-new-tag" size="small" @click="showInputTag">+ 新增成员</el-button>
                        </div>

                    </div>
                    <div class="my_form">
                        <div class="form_title" style="height: 62px">
                            课题名称
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.project_title" @blur="checkedRepeat" placeholder="请输入课程名称（同一企业申请课程名称不允许重复提交）" type="text">
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title" style="height: 62px">
                            课题类型
                        </div>
                        <div class="form_long">
                            <el-radio-group v-model="ruleForm.project_type" size="small" class="inpyabeb">
                                <el-radio label="问题解决型">问题解决型</el-radio>
                                <el-radio label="创新型">创新型</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="my_form">
                        <div class="form_title" style="height: 62px">
                            工程名称
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.work_name" placeholder="请输入工程名称" type="text">
                        </div>
                    </div>
                    <div class="flex">
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">工程类别</div>
                        <div class="form_content" style="width:400px">
                             <el-radio-group v-model="ruleForm.work_type" size="small" class="inpyabeb">
                                 <el-radio label="房屋建筑市政工程">房屋建筑市政工程</el-radio>
                                 <el-radio label="土木工程">土木工程</el-radio>
                                 <el-radio label="工业安装工程">工业安装工程</el-radio>

                             </el-radio-group>
                        </div>
                      </div>
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">工程所在地</div>
                        <div class="form_content" style="width:185px">
                          <div class="input" >
                            <input style="width:100%" type="text" placeholder="工程所在地" v-model="ruleForm.work_address" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="my_form">
                        <div class="form_title" style="height: 62px">
                            小组活动推进者姓名
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.work_user_name" placeholder="请输入小组活动推进者姓名" type="text">
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title" style="height: 62px">
                            小组活动结束时间
                        </div>
                        <div class="form_long">
                            <el-date-picker v-model="ruleForm.end_time" type="date" value-format="yyyy年MM月dd日" format="yyyy年MM月dd日"
                                            placeholder="选择日期" class="end-time--picker"></el-date-picker>
                        </div>
                    </div>
                   <!-- <div class="my_form2">
                        <div class="form_title" style="height: 62px">
                            指导者/推进者证书有效期
                        </div>
                        <div class="form_long">
                            <el-date-picker v-model="ruleForm.guide_expire_date" type="daterange" value-format="yyyy年MM月dd日" format="yyyy年MM月dd日"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期" class="end-time--picker"></el-date-picker>
                        </div>
                    </div> -->
                    <div class="my_form">
                        <div class="form_title" style="height: 62px">
                            推进者培训结业证书颁发机构
                        </div>
                        <div class="form_long">
                            <input v-model="ruleForm.guide_org" placeholder="点击输入" type="text">
                        </div>
                    </div>
                    <div class="flex">
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">联系人</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入联系人" v-model="ruleForm.linker" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">联系电话</div>
                        <div class="form_content" style="flex-direction:column">
                          <div class="input">
                            <input type="text" placeholder="请输入联系电话" v-model="ruleForm.tel" />
                          </div>
                          <div class="input-tip">该电话用于接收审核结果</div>
                        </div>
                      </div>
                    </div>

                </el-tabs>
            </el-form>
        </div>
        <div id="sj_upload" class="form_1">
            <tips title="申报材料上传" background="#FEF8EF" border="#FFB700" :states="uploadFull"></tips>
            <el-form ref="ruleForm" style="margin-top: 16px">
                <el-tabs v-model="activeName">
                    <div class="my_form">
                        <div class="form_title">
                            工程建设质量管理小组竞赛活动成果报名表
                        </div>
                        <div class="upload-file--container bg-gray1">
                            <el-upload class="upload-demo"
                                       :action="'/api/home/upload/file/user'"
                                       accept=".pdf" :limit="1"
                                       :file-list="ruleForm.reportforms"
                                       :on-remove="() => handleOnRemove('reportforms')"
                                       :on-success="(res) => uploadSuccess(res, 'reportforms')" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>
                            </el-upload>
                            <div class="upload-file--tip">
                                在系统上填写，下载打印盖章，再扫描上传
                            </div>
                            <a class="upload-file--file" target="_blank" href="/user/附件2：工程建设质量管理小组竞赛活动成果报名表.docx">
                                工程建设质量管理小组竞赛活动成果报名表.docx
                            </a>
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title">
                            工程建设质量管理小组竞赛活动成果汇总表
                        </div>
                        <div class="upload-file--container bg-gray2">
                            <el-upload class="upload-demo"
                                       :action="'/api/home/upload/file/user'"
                                       accept=".pdf" :limit="1"
                                       :file-list="ruleForm.reportfiles"
                                       :on-remove="() => handleOnRemove('reportfiles')"
                                       :on-success="(res) => uploadSuccess(res, 'reportfiles')" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>
                            </el-upload>
                            <div class="upload-file--tip">
                                下载填写打印盖章，再扫描上传
                            </div>
                            <a class="upload-file--file" target="_blank" href="/user/附件3：2025年度工程建设质量管理小组竞赛活动成果汇总表.xls">
                                2025年度工程建设质量管理小组竞赛活动成果汇总表.xls
                            </a>
                        </div>
                    </div>
                    <div class="my_form">
                        <div class="form_title">
                            质量管理小组活动成果电子版材料（PDF版，直接上传）
                        </div>
                        <div class="upload-file--container bg-gray1">
                            <el-upload class="upload-demo"
                                       :action="'/api/home/upload/file/user'"
                                       accept=".pdf" :limit="1"
                                       :file-list="ruleForm.reportinfos"
                                       :on-remove="() => handleOnRemove('reportinfos')"
                                       :on-success="(res) => uploadSuccess(res, 'reportinfos')" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title">
                            推进者有效期内培训结业证书扫描件（PDF版，直接上传）
                        </div>
                        <div class="upload-file--container bg-gray1">
                            <el-upload class="upload-demo"
                                       :action="'/api/home/upload/file/user'"
                                       accept=".pdf" :limit="1"
                                       :file-list="ruleForm.reportjieye"
                                       :on-remove="() => handleOnRemove('reportjieye')"
                                       :on-success="(res) => uploadSuccess(res, 'reportjieye')" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="my_form">
                        <div class="form_title">
                            近三年小组成员参与质量管理小组活动培训情况汇总表
                        </div>
                        <div class="upload-file--container bg-gray1">
                            <el-upload class="upload-demo"
                                       :action="'/api/home/upload/file/user'"
                                       accept=".pdf" :limit="1"
                                       :file-list="ruleForm.reporthuizong"
                                       :on-remove="() => handleOnRemove('reporthuizong')"
                                       :on-success="(res) => uploadSuccess(res, 'reporthuizong')" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>
                            </el-upload>
                            <div class="upload-file--tip">
                                下载填写打印盖章，再扫描上传
                            </div>
                            <a class="upload-file--file" target="_blank" href="/user/附件4：近三年小组成员参与质量管理小组活动培训情况汇总表（2023-2025年）.doc">
                                近三年小组成员参与质量管理小组活动培训情况汇总表（2023-2025年）.doc
                            </a>
                        </div>
                    </div>
                    <div class="my_form2">
                        <div class="form_title">
                            企业承诺书
                        </div>
                        <div class="upload-file--container bg-gray1">
                            <el-upload class="upload-demo"
                                       :action="'/api/home/upload/file/user'"
                                       accept=".pdf" :limit="1"
                                       :file-list="ruleForm.reportchengnuo"
                                       :on-remove="() => handleOnRemove('reportchengnuo')"
                                       :on-success="(res) => uploadSuccess(res, 'reportchengnuo')" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>
                            </el-upload>
                            <div class="upload-file--tip">
                                下载填写打印盖章，再扫描上传
                            </div>
                            <a class="upload-file--file" target="_blank" href="/user/附件5：企业承诺书.docx">
                                企业承诺书.docx
                            </a>
                        </div>
                    </div>
                    <!-- <div class="my_form2">
                        <div class="form_title">
                            推进者证书扫描件或其他有效证明文件（至少两份）
                        </div>
                        <div class="upload-file--container bg-gray2">
                            <div  v-for="(guidecerts, index) in guidecertsArr" :key="index">
                            <el-upload
                                :key="`guidecerts-${index}`"
                                class="upload-demo"
                                :action="$baseURL + '/api/home/upload/file/user'"
                                accept=".pdf" :limit="1"
                                :file-list="guidecerts"
                                :on-remove="(file) => handleOnRemoveGuidecerts(index)"
                                :on-success="(res, fileList) => uploadSuccessGuidecerts(res, index)" :before-upload="beforePdfUpload">
                                <div class="form-upload-div">
                                    <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                                    <div slot="tip" class="el-upload__tip">
                                        仅支持pdf格式，大小不超过100mb
                                    </div>
                                </div>

                            </el-upload>
                                <a style="color: red;margin-top: -35px;margin-right: 350px;float: right" v-if="index>1"  v-on:click = "deleGuidecerts({index})">X</a>
                            </div>
                            <el-button
                                size="small"
                                style="color: #194abe; margin: 10px 20px;"
                                @click="addGuidecerts">
                                新增附件
                            </el-button>
                        </div>
                    </div> -->
                </el-tabs>
            </el-form>
        </div>
    </div>
</template>

<script>
import Tips from '../../components/Modal/tips' //提示组件
import {  applyCheckedRepeat } from "../../utils/api";

export default {
    components: {
        Tips
    },
    data() {
        return {
            ruleForm: {
                company: '',
                group: '',
                group_people_num: '',
                group_people: [],
                project_title: '',
                project_type: '',
                end_time: '',
                guide_org: '',
                reportforms: [],
                reportfiles: [],
                reportinfos: [],
                reportjieye: [],
                reporthuizong: [],
                reportchengnuo: [],
                guidecerts: [],
                linker:'',
                tel:''
            },
            rules: {},
            activeName: '',
            basicFull: false,
            uploadFull: false,
            inputVisible: false,
            inputValue: '',
            id:0,
            award_id:0,
            award_batch_id:0,
            guidecertsArr: [
                [],
                []
            ],// 实现附件一次一个上传按钮
            is_repeat:0
        }
    },
    watch: {
        ruleForm: {
            handler(val) {
                this.judgeBasicFull()
            },
            deep: true
        }
    },
    methods: {
        judgeBasicFull() {
            const { ruleForm } = this
            const basicFields = [
                'company', 'group', 'group_people_num', 'group_people',
                'project_title', 'project_type', 'end_time', 'guide_org','linker','tel',//, 'guide_expire_date'
                'work_name','work_type','work_address','work_user_name'

            ]
            const isFull = basicFields.every(key => ruleForm[key]) && this.is_repeat == 0;
            this.basicFull = isFull
            this.$emit('changeBasicFull', isFull)
            return isFull
        },
        judgeUploadFull() {
            const { ruleForm } = this
            const basicFields = [
                'reportforms', 'reportfiles', 'reportinfos','reportjieye','reporthuizong','reportchengnuo'
            ]
            const isFull = basicFields.every(key => {
                return Array.isArray(ruleForm[key]) && ruleForm[key].length > 0
            })
            console.log('judgeUploadFull',isFull)
            // console.log('this.guidecertsArr.length',this.guidecertsArr.length)
            // console.log('this.guidecertsArr.length',this.guidecertsArr)
            // const guidecertsFull = this.guidecertsArr.length >= 2 && this.guidecertsArr.every(function(item,index){
            //     console.log('this.guidecertsArr.length',Array.isArray(item))
            //     console.log('this.guidecertsArr.length',item.length)
            //     if(index > 1){
            //         return true;
            //     }
            //     return Array.isArray(item) && item.length > 0
            // })
            this.uploadFull = isFull;// && guidecertsFull
            this.$emit('changeUploadFull', this.uploadFull)
            return isFull
        },
        beforePdfUpload(file) {
          let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
          console.log(file);
          if (filesize > 100) {

            this.$message.error("上传文件不能大于100MB");
            return false;
          }
          //检查文件类型
          const fileName = file.name;
          const fileType = fileName.substring(fileName.lastIndexOf('.'));
          console.log('fileType',fileType)
          if(fileType != '.pdf'){
              this.$message.error("只能上传pdf文件");
              return false;
          }

        },
        setData(data = {}) {
            this.ruleForm = {
                ...data,
                group_people: data.group_people ? (data.group_people || '').split(',') : []
            }
            // this.guidecertsArr = (data.guidecerts || []).reduce((res, item) => {
            //     res.push([item])
            //     return res
            // }, [])
            // for(let i = 0; i < 2; i++) {
            //     if (!this.guidecertsArr[i]) {
            //         this.guidecertsArr.push([])
            //     }
            // }
            this.judgeUploadFull()
        },
        setInfo(id,award_id,award_batch_id){
            this.id = id;
            this.award_id = award_id;
            this.award_batch_id = award_batch_id;
            },
        getData() {
            const data = JSON.parse(JSON.stringify(this.ruleForm))
            // data.guidecerts = this.guidecertsArr.reduce((res, item) => {
            //     res = res.concat(item)
            //     return res
            // }, [])
            data.guidecerts = [];
            data.group_people = (data.group_people || []).join(',')
            return data
        },
        handleOnRemove(key, file) {
            this.ruleForm[key] = []
            this.judgeUploadFull()
        },
        uploadSuccess(response, key, fileList) {
            const file = {
                url: response.data.host + response.data.url,
                name: response.data.originalName
            }
            this.ruleForm[key] = [file]
            this.judgeUploadFull()
        },
        handleCloseTag(tag) {
            this.ruleForm.group_people.splice(this.ruleForm.group_people.indexOf(tag), 1)
        },
        showInputTag() {
            this.inputVisible = true
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus()
            })
        },

        handleInputTagConfirm() {
            let inputValue = this.inputValue
            if (inputValue) {
                if (!this.ruleForm.group_people) {
                    this.$set(this.ruleForm, 'group_people', [])
                }
                this.ruleForm.group_people.push(inputValue)
            }
            this.inputVisible = false
            this.inputValue = ''
        },
        uploadSuccessGuidecerts(response, index) {
            const file = {
                url: response.data.host + response.data.url,
                name: response.data.originalName
            }
            this.guidecertsArr[index] = [file]
            this.judgeUploadFull()
        },
        handleOnRemoveGuidecerts(index) {
            this.guidecertsArr[index] = []
            this.judgeUploadFull()
        },
        addGuidecerts() {
            this.guidecertsArr.push([])
        },
        deleGuidecerts(index){
            console.log('index.index',index.index)
            console.log('index.index',index['index'])
            console.log('index',index)
            this.guidecertsArr.splice(index.index,1);
        },
        //检查企业+课题是否重复
        checkedRepeat(){
            if(this.ruleForm.company && this.ruleForm.project_title){
                return applyCheckedRepeat({'award_id':this.award_id,'award_batch_id':this.award_batch_id,'id':this.id,'company':this.ruleForm.company,'project_title':this.ruleForm.project_title}).then(res => {
                this.is_repeat = 0;
              }).catch(err => {
                 this.is_repeat = 1;
                 this.$alert(err, {
                   confirmButtonText: '我知道了',
                 });
                //this.$message.error()
              });

            }
            this.judgeUploadFull()
            return true;

        }
    }
}
</script>

<style lang="less" scoped>
@import '../myform.less';
.bg-gray1 {
  background: #f5f8fb;
}
.bg-gray2 {
  background: #fbfdff;
}
.group-award {
  .upload-file--container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .upload-file--container2 {
    padding: 9px 23px;
    width: 100%;
    text-align: left;
  }
  .upload-file--tip {
    padding: 0 20px;
    font-size: 12px;
  }

  .upload-file--file {
    margin: 5px 20px 20px;
    font-size: 12px;
    color: blue;
  }
  .form_title--with-tip {
    flex-direction: column;
    align-items: flex-start;
  }
  .form_title--with-tip .title-desc {
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
    margin-top: 2px;
  }
  .input-tip {
    margin-top: 6px;
    font-size: 12px;
    color: #ff4d4f;
  }
}
.end-time--picker {
  width: calc(100% - 30px) !important;
}
.group-people--container {
  width: 100%;
  padding: 15px 20px;
  background: #fbfdff;
  text-align: left;
}
.group-people--tag {
  margin: 2px 5px;
}
.input-new-tag {
  width: 100px;
}
</style>
